import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import Button from '../button';
import _ from 'lodash';
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle
} from '~/components/ui/dialog';
import { Input } from '~/components/ui/input';

const ConfirmModal = ({
						  show,
						  proceed,
						  title,
						  content,
						  cancelText,
						  confirmText,
						  cancelVariant = 'secondary',
						  confirmVariant = 'primary',
						  textField
}) => {

	const [textFieldValue, setTextFieldValue] = useState('');

	return (
		<Dialog open={show} onOpenChange={(open) => !open && proceed(false)}>
			<DialogContent
				className="border-border bg-card text-card-foreground"
				style={{
					width: 'min(520px, calc(100vw - 2rem))',
					maxWidth: '520px'
				}}
				aria-label={title}
				onInteractOutside={(event) => event.preventDefault()}
				onEscapeKeyDown={(event) => {
					event.preventDefault();
					proceed(false);
				}}
			>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<div className="px-8 pt-2 space-y-4">
					<span className="block text-sm text-muted-foreground">{content}</span>
					{textField && <Input
						type="text"
						name="confirmMessage"
						id="confirmMessage"
						value={textFieldValue}
						onChange={(e) => setTextFieldValue(e.target.value)}
					/>
					}
				</div>

				<DialogFooter className="px-8 pb-7">
					<Button
						variant={cancelVariant}
						lighten
						onClick={() => proceed(false)}
						data-testid="confirm-cancel"
					>
						{cancelText}
					</Button>
					<Button
						variant={confirmVariant}
						lighten
						disabled={(textField && _.isEmpty(textFieldValue)) || false}
						onClick={() => proceed( textField ? textFieldValue : true)}
						data-testid="confirm-ok"
					>
						{confirmText}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);

};

ConfirmModal.propTypes = {
	show: PropTypes.bool,
	proceed: PropTypes.func,
	title: PropTypes.string,
	textField: PropTypes.bool,
	content: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
	cancelText: PropTypes.string,
	confirmText: PropTypes.string,
	cancelVariant: PropTypes.oneOf([
		'primary', 'secondary', 'warning', 'danger', 'ghost-primary'
	]),
	confirmVariant: PropTypes.oneOf([
		'primary', 'secondary', 'warning', 'danger', 'ghost-primary'
	])
};

export default createConfirmation(confirmable(ConfirmModal));
